import React from 'react';

import { Banner } from '@repo/common';

import { ReactComponent as IdeaIcon } from '@repo/common/assets/icons/20px/icon_20px_idea-outline.svg';

const EducationBanner = ({ $isMobile }) => {
  return (
    <div className='min-w-[280px] tabletH:max-w-[344px] w-full flex flex-col items-start gap-2'>
      <Banner
        type='info'
        size='s'
        label='For Korean resumes, start with your high school and list each degree onward.'
        labelKr='한국 이력서는 고등학교부터 시작해 각 학력을 순서대로 작성해 주세요.'
        className='px-3 py-2.5 tabletH:p-4'
        hideButton
        hideClose={!$isMobile}
        icon={<IdeaIcon />}
      />
    </div>
  );
};

export default EducationBanner;
